export default "__VITE_ASSET__DhGdandZ__"